import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';

interface InitProps {
  dsn: string;
  release: string;
  environment?: string;
}

export const SentryInit = ({ dsn, release, environment }: InitProps) =>
  Sentry.init({
    dsn,
    release,
    environment,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new Integrations.BrowserTracing(),
      new CaptureConsoleIntegration({
        // array of methods that should be captured
        // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
        levels: ['error'],
      }),
      new Sentry.Replay({ maskAllText: false, blockAllMedia: false }),
    ],
  });

export const SentryErrorBoundary = Sentry.ErrorBoundary;
